import classNames from 'classnames';
import { A, svgSprite } from '../../../../../../hybrid/wrappers';
import uikit from '../../../../../../project/uikit/uikit.module.scss';
import defaultCss from './SingleMenuItem.module.scss';
import SingleMenuItemSub from '../SingleMenuItemSub/SingleMenuItemSub';
import SingleMenuItemTitle from '../SingleMenuItemTitle/SingleMenuItemTitle';
import { useMemo } from 'react';

const SingleMenuItem = ({
    setShowSubMenu,
    setShowSubMenuIdx,
    menuItem,
    isMobile,
    componentCss,
    showSubMenu,
    idx,
    active,
    showSubMenuIdx,
    isStorePage,
    showCategoriesGT
}) => {
    const isActive = useMemo(() => {
        return menuItem.asLink === active;
    }, [menuItem, active]);

    const href =
        menuItem.type === 'outLink'
            ? `https://${menuItem.asLink}`
            : menuItem.type === 'link' || menuItem.type === 'page'
            ? `${menuItem.type === 'page' ? '/page' : ''}${menuItem.asLink}`
            : 'javascript:void(0)';

    if (!menuItem.activity) return null;
    return (
        <div className={classNames(componentCss?.wrapperItem, isMobile ? uikit.flexColumn : null)}>
            <A
                target={menuItem.type !== 'part' && menuItem?.target ? '_blank' : '_self'}
                href={href}
                {...(menuItem.type === 'part' && menuItem?.submenu?.length
                    ? {
                          onClick: (e) => {
                              e.preventDefault();
                              if (menuItem?.submenu?.length) {
                                  setShowSubMenu((prev) => {
                                      !prev ? setShowSubMenuIdx(idx) : setShowSubMenuIdx(-1);
                                      return !prev;
                                  });
                              }
                          }
                      }
                    : {})}
                {...(isStorePage && menuItem?.type === 'link' && menuItem?.link === '/store'
                    ? {
                          onMouseOver: () => {
                              typeof showCategoriesGT === 'function' && showCategoriesGT((s) => !s);
                          }
                      }
                    : {})}
                className={classNames(defaultCss.mainMenuItem, componentCss?.mainMenuItem)}
                style={{
                    ...(showSubMenu && idx === showSubMenuIdx ? { paddingBottom: '0' } : {})
                }}
            >
                <span className={componentCss?.officeMenuItemText}>
                    {menuItem.type === 'outLink' ? (
                        <span
                            className={classNames(
                                defaultCss.officeMenuItemTextP,
                                componentCss?.officeMenuItemTextP,
                                isActive && componentCss?.officeMenuItemTextHover
                            )}
                        >
                            <span className={componentCss?.itemMenuStyle}>
                                <SingleMenuItemTitle
                                    {...{ isMobile, componentCss, menuItem, showSubMenu, idx, showSubMenuIdx }}
                                />
                            </span>
                        </span>
                    ) : menuItem.type === 'link' || menuItem.type === 'page' ? (
                        <span
                            className={classNames(
                                defaultCss.officeMenuItemTextP,
                                componentCss?.officeMenuItemTextP,
                                isActive && componentCss?.officeMenuItemTextHover
                            )}
                        >
                            <span
                                className={classNames(
                                    defaultCss.itemMenuStyle,
                                    componentCss?.itemMenuStyle,
                                    isActive && componentCss?.officeMenuItemTextHover
                                )}
                            >
                                <SingleMenuItemTitle
                                    {...{ isMobile, componentCss, menuItem, showSubMenu, idx, showSubMenuIdx }}
                                />
                            </span>
                        </span>
                    ) : (
                        <span
                            className={classNames(
                                defaultCss.officeMenuItemTextP,
                                componentCss?.officeMenuItemTextP,
                                isActive && componentCss?.officeMenuItemTextHover
                            )}
                        >
                            <SingleMenuItemTitle {...{ isMobile, componentCss, menuItem, showSubMenu, idx, showSubMenuIdx }} />
                        </span>
                    )}
                    {!!menuItem.submenu.length && !!isMobile
                        ? svgSprite('angle-right', {
                              className: classNames(
                                  componentCss?.officeMenuItemArrowMob,
                                  showSubMenu && idx === showSubMenuIdx ? componentCss?.officeMenuItemArrowMobRotate : null
                              )
                          })
                        : null}
                    {!!menuItem.submenu.length && !isMobile ? (
                        <span className={defaultCss.officeMenuItemArrowDownWrapper}>
                            {svgSprite('angle-down', {
                                style: {
                                    width: '7.5px',
                                    height: '3.75px',
                                    ...(componentCss?.officeMenuItemTextSvgFill
                                        ? {}
                                        : {
                                              fill: 'var(--darkHalfTransparentColor)'
                                          }),
                                    ...(showSubMenu && idx === showSubMenuIdx
                                        ? { transform: 'rotate(180deg)' }
                                        : { transform: 'rotate(0)' }),
                                    transition: 'all .3s ease',
                                    className: componentCss?.officeMenuItemTextSvgFill
                                }
                            })}
                        </span>
                    ) : null}
                </span>
            </A>
            {menuItem?.submenu.length ? (
                <SingleMenuItemSub
                    {...{ componentCss, showSubMenu, idx, showSubMenuIdx, menuItem, active, isActive, isMobile }}
                />
            ) : null}
        </div>
    );
};
export default SingleMenuItem;
